import { axiosInstance } from "./AxiosDefaults";
import { Notification } from "../models/Notification";

export const getAllMobileNotifications = (): Promise<any> => {
  return axiosInstance.get("/mobile-notifications", {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createMobileNotification = (notification: any): Promise<any> => {
  return axiosInstance.post(`${`/mobile-notifications`}`, notification, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getMobileNotification = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/mobile-notifications`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateMobileNotification = async (
  id: string,
  notification: Notification
): Promise<any> => {
  return axiosInstance.put(`${"/mobile-notifications"}/${id}`, notification, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteNotification = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/mobile-notifications"}/${id}`);
};
